<aside class="flex h-full min-h-0 w-full flex-col bg-white">
  <div class="flex shrink-0 flex-col gap-1 border-b border-slate-100 px-4 py-4">
    <h2 class="text-sm font-semibold text-slate-950">Page</h2>
    <p class="text-xs leading-5 text-slate-500">
      Settings for this step only — title, description, and button labels.
    </p>
  </div>

  @if (page(); as current) {
    <div class="flex min-h-0 flex-1 flex-col gap-4 overflow-y-auto px-4 py-4">
      <lib-signal-text-field
        label="Page title"
        placeholder="e.g. Basic details"
        [value]="draft().title"
        [debounceValueChange]="false"
        (valueChange)="updateDraft('title', $event)" />

      <lib-signal-textarea
        label="Page description"
        placeholder="Optional helper text for this step"
        [rows]="3"
        [value]="draft().description"
        [debounceValueChange]="false"
        (valueChange)="updateDraft('description', $event)" />

      <lib-signal-text-field
        label="Primary button"
        [placeholder]="current.order === 1 && !canDelete() ? 'Submit' : 'Next'"
        [value]="draft().primaryLabel"
        [debounceValueChange]="false"
        (valueChange)="updateDraft('primaryLabel', $event)" />

      @if (current.order > 1) {
        <lib-signal-text-field
          label="Back button"
          placeholder="Back"
          [value]="draft().backLabel"
          [debounceValueChange]="false"
          (valueChange)="updateDraft('backLabel', $event)" />
      }

      @if (canDelete()) {
        <button
          type="button"
          class="mt-2 self-start rounded-lg border border-rose-200 px-3 py-2 text-xs font-semibold text-rose-700 transition hover:bg-rose-50"
          (click)="onDelete()">
          Delete page
        </button>
      }
    </div>
  } @else {
    <div class="flex flex-1 items-center justify-center px-6 py-10 text-center">
      <p class="text-sm text-slate-500">No page selected.</p>
    </div>
  }
</aside>
